import type {
  CreateDesignationInput,
  DataResponse,
  Designation,
  PaginatedResponse,
  PaginationQuery,
  UpdateDesignationInput,
} from '@pms/shared';
import { api } from '@/lib/api';

export const designationsService = {
  async list(query: Partial<PaginationQuery> = {}): Promise<PaginatedResponse<Designation>> {
    const res = await api.get<PaginatedResponse<Designation>>('/designations', { params: query });
    return res.data;
  },

  async get(id: string): Promise<Designation> {
    const res = await api.get<DataResponse<Designation>>(`/designations/${id}`);
    return res.data.data;
  },

  async create(input: CreateDesignationInput): Promise<{ id: string }> {
    const res = await api.post<DataResponse<{ id: string }>>('/designations', input);
    return res.data.data;
  },

  async update(id: string, input: UpdateDesignationInput): Promise<void> {
    await api.patch(`/designations/${id}`, input);
  },

  async deactivate(id: string): Promise<void> {
    await api.delete(`/designations/${id}`);
  },
};
